import { useState } from "react";

export default function ReminderList({ items, onAdd, onRemove }) {
  const [text, setText] = useState("");

  return (
    <div>
      <div className="flex gap-2">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add a reminder…"
          className="flex-1 rounded-xl bg-white/80 dark:bg-zinc-900/50 ring-1 ring-black/10 dark:ring-white/10 px-3 py-2 text-sm outline-none"
        />
        <button
          onClick={() => {
            onAdd(text);
            setText("");
          }}
          className="rounded-xl bg-zinc-900 dark:bg-white text-white dark:text-zinc-900 px-4 text-sm font-semibold"
        >
          Add
        </button>
      </div>

      <div className="mt-3 space-y-2">
        {items.length === 0 ? <div className="text-sm text-zinc-500 dark:text-zinc-400">No reminders yet.</div> : null}
        {items.map((x, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between gap-2 rounded-xl bg-white/70 dark:bg-zinc-900/40 ring-1 ring-black/10 dark:ring-white/10 px-3 py-2"
          >
            <div className="text-sm">{x}</div>
            <button
              onClick={() => onRemove(idx)}
              className="text-xs font-semibold px-2 py-1 rounded-lg bg-zinc-100 dark:bg-zinc-800"
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
